import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import axios from 'axios'
import Dialog from "../../../common/Dialog";
import SimpleList from "../../../common/SimpleList";

@connect(state => ({
  post: state.post.newPost
}))
class TemplateDialog extends Component {

  constructor(props) {
    super(props)
    this.state = {
      list: []
    }
  }

  componentDidMount() {
    axios
      .get(`${appInfo.manageUrl}/post/templates.json`)
      .then(r => r.data)
      .then(data => {
        if (data && Array.isArray(data)) {
          this.setState({
            list: data
          })
        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  @autobind
  handleApplyTemplate(item) {
    const { onApply } = this.props
    axios
      .get(`${appInfo.manageUrl}/post/template/${item.id}.json`)
      .then(r => r.data)
      .then(data => {
        onApply(data)
      })
      .catch(e => {
        console.error(e)
      })
  }

  renderBody() {
    const { list } = this.state
    if (list.length > 0) {
      return (
        <SimpleList
          onSelect={this.handleApplyTemplate}
          list={list}
        />
      )
    } else {
      return <div className={'message'}>작성한 서식이 없습니다</div>
    }
  }

  render() {
    const { open, onClose } = this.props

    const actions = [
      {
        label: '닫기',
        handler: onClose
      }
    ]

    return (
      <Dialog className={'template-layer'} open={open} title={'서식'} onClose={onClose} actions={actions}>
        <div className={'template-layer-body'}>
          {this.renderBody()}
        </div>
      </Dialog>
    )
  }
}

export default TemplateDialog
